<div
  class="tw-flex tw-flex-col tw-gap-4 xl:!tw-items-center xl:!tw-flex-row xl:!tw-justify-between"
>
  <div class="tw-flex tw-flex-row">
    <div class="tw-flex tw-flex-row tw-items-center tw-gap-8">
      <label
        class="tw-text-gray-700 tw-font-bold tw-mb-0 tw-w-36"
        [hidden]="!showLabel"
        >Distribution</label
      >

      <mat-slide-toggle
        [disabled]="!!readonly"
        class="tw-mr-1"
        id="allDisplaysToggle{{ inputId }}"
        (change)="outputDistributeToAll()"
        [(ngModel)]="distributeToAll"
        [attr.aria-label]="
          'Show on all displays' +
          (enableSubcompanyDistributeToAll ? ' in this company' : '')
        "
      >
        <span class="tw-ml-2" [class.tw-cursor-pointer]="!readonly"
          >Show on all displays{{
            enableSubcompanyDistributeToAll ? ' in this company' : ''
          }}.</span
        >
      </mat-slide-toggle>
    </div>
  </div>

  @if (!distributeToAll) {
    @if (!readonly) {
      <span
        id="distributionField{{ inputId }}"
        class="tw-text-blue-600 tw-cursor-pointer hover:tw-text-blue-800 tw-underline tw-flex tw-items-end tw-text-right"
        timeline="timeline"
        (click)="manage()"
        tabindex="0"
        (keyup.enter)="manage()"
        >{{ distributionSelectionMessage }}
      </span>
    } @else {
      <span class="tw-flex tw-items-end tw-text-right">{{
        distributionSelectionMessage
      }}</span>
    }
  }
</div>

@if (subcompanyDistributeToAllAvailable) {
  <div class="tw-flex tw-flex-row tw-mt-[8px]">
    <div class="tw-flex tw-flex-row tw-items-center">
      <mat-slide-toggle
        [disabled]="!!readonly"
        class="tw-mr-1"
        id="allSubcompanyDisplaysCheckbox{{ inputId }}"
        (change)="outputSubcompanyDistributeToAll()"
        [(ngModel)]="subcompanyDistributeToAll"
        aria-labelledby="subcompanyDistributeToAllLabel{{ inputId }}"
      >
        <span
          id="subcompanyDistributeToAllLabel{{ inputId }}"
          class="tw-ml-2 tw-truncate"
          [class.tw-cursor-pointer]="!readonly"
          >Show on all displays in sub companies.</span
        >
      </mat-slide-toggle>
    </div>
  </div>
}
